export default {
  success({ toast, title, message }) {
    toast.success({
      title: title || 'Success',
      message: message || 'Successfully',
      color: '#7fb069',
    })
  },
  error({ toast, title, message }) {
    toast.error({
      title: title || 'Error',
      message: message || 'Something went wrong',
      color: '#a21010',
    })
  },
  notImplemented({ toast }) {
    toast.error({
      title: 'Error',
      message: 'Not implemented',
      color: '#a21010',
    })
  },
  validationFieldsError({ toast }) {
    toast.error({
      title: 'Error',
      message: 'Please fill the fields.',
      // title: 'The entered data is not valid',
      color: '#a21010',
    })
  },
}



// WEBPACK FOOTER //
// ./src/services/toast.js